import {PermissionList} from '@/shared/components/ui/permission-list'
import {useUserContext} from '@/shared/contexts'
import {getUserPermissions} from '@cypro/engine/utils'
import {Badge, VStack} from '@chakra-ui/react'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function GroupAndPermissionsTab() {
  const {t} = useTranslate('common')
  const {user} = useUserContext()

  const groups = user.groups ?? []
  const permissions = getUserPermissions(groups)

  return (
    <Tabs.Content value="group_permissions" spaceY="8" display="flex" flexDirection="column">
      <DataSection label={t('group_&_permissions')}>
        <VStack align="stretch" gap="2">
          {groups.map(group => (
            <Badge key={group.id} variant="subtle" width="max-content">
              {group.name}
            </Badge>
          ))}
        </VStack>
      </DataSection>

      <PermissionList granted={permissions} />
    </Tabs.Content>
  )
}
